import { DatePipe } from '@angular/common';
import { Component, EventEmitter, ElementRef, Inject, Input, OnInit, TemplateRef, ViewChild, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ICellRendererParams } from 'ag-grid-community';
import { differenceInCalendarDays } from 'date-fns';
import { tr } from 'date-fns/locale';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/internal/operators/finalize';
import { PriorityLevel } from 'src/@smartmanufacturing/common/enum';
import { ImageDialogComponent } from 'src/app/analytical-tools/image-dialog/image-dialog.component';
import { MeetingMatrixService } from 'src/app/services/meeting-matrix.service';
import { OverallActionPlanService } from 'src/app/services/overall-actionPlan.service';
import { TranslaterService } from 'src/app/services/translater.service';
import { UserConfigurationsService } from 'src/app/services/user-configurations.service';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';
import { BaseApi } from 'src/backend/api/base-api';
import { PermissionService } from 'src/backend/services/permission.service';
import { EmployeeService } from 'src/backend/services/user-access-services/employee.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-Action-modal',
  templateUrl: './Action-modal.component.html',
  styleUrls: ['./Action-modal.component.scss']
})
export class ActionModalComponent implements OnInit {
  @Output() actionSaveUpdateEvent: EventEmitter<any> = new EventEmitter();
  langObj: any;
  addActionForm: FormGroup;
  @ViewChild('addActionModal') private addActionModal!: TemplateRef<any>;
  @ViewChild('imageInput') imageInput!: ElementRef;
  @ViewChild('fileInput') fileInput!: ElementRef;
  Headerform!: FormGroup;
  masterUserList: any = [];
  gridApiActions: any;
  gridColumnApiActions: any;
  columnDefsallAction: any;
  editMode: boolean = false;
  overallActions: any[];
  Status: any;
  departmentListMachine!: any;
  filteredDepartmentListMachine!: any;
  actionSelectedRow: any;
  blobStorageUrl = environment.blobStorageUrl;
  actionId: any;
  displayMaximizable = false;
  imageIndexOne = 0;
  ModuleName: any;
  UniqueCode: any;
  HeaderId: any;
  isAccess = ApplicationPermission.DEFECT_Configuration_ACCESS;
  isCreate = ApplicationPermission.DEFECT_Configuration_CREATE;
  isUpdate = ApplicationPermission.DEFECT_Configuration_UPDATE;
  isDelete = ApplicationPermission.DEFECT_Configuration_DELETE;
  currentAssigneeEmail: string = null;
  currentResponsibleEmail: any = null;
  currentNodeDate: any = null;
  showDepartment: boolean = true;
  addStatus = 'Open';
  addClosedDate: any;
  addVerificationBy: string = '';
  doc!: any;
  images: any[] = [];
  fileType!: string;
  fileDesc: any;
  imagefile: any;
  imagefileUrl: any;
  filefile: any;
  filefileUrl: any;
  closefile: any;
  closefileUrl: any;
  completefile: any;
  completefileUrl: any;
  mClassificationTypes: any[] = [];
  pageId: any;
  moduleId: any;
  languageDir = 'ltr';
  MissesCondition: boolean;
  nzDateTimeFormat: any;
  nzDateFormat: any;
  nzTimeFormat: any;
  userSession: any;
  Levels = [
    { Id: PriorityLevel.High, Name: 'High' },
    { Id: PriorityLevel.Medium, Name: 'Medium' },
    { Id: PriorityLevel.Low, Name: 'Low' }
  ];
  overallMeetingActions: any;
  employees: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public inputData: {
      message: string,
      userList: [],
      ID: any,
      ModuleId: any,
      editMode: any,
      params: any,
      TableId: any,
      visible: any,
      viewHeader: any,
    },

    private dialogRef: MatDialogRef<ActionModalComponent>,
    private dialog: MatDialog,
    private toaster: ToastrService,
    public datePipe: DatePipe,
    private employeeService: EmployeeService,
    private meetingService: MeetingMatrixService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    public translate: TranslateService,
    private permissionService: PermissionService,
    private actionplanService: OverallActionPlanService,
    private baseApi: BaseApi,
    private translater: TranslaterService,
    private userConfigService: UserConfigurationsService
  ) {
    this.nzDateTimeFormat = this.userConfigService.getDateFormat('date-time');
    this.nzDateFormat = this.userConfigService.getDateFormat('date');
    this.nzTimeFormat = this.userConfigService.getDateFormat('time');
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ? this.languageDir = 'rtl' : this.languageDir = 'ltr'; this.getLangWords(); });
    this.addActionForm = this.fb.group({
      rootcause: [''],
      action: ['', Validators.required],
      mClassification: [''],
      actionType: ['', Validators.required],
      assignTo: ['', Validators.required],
      priorityLevel: ['', Validators.required],
      targetDate: ['', Validators.required],
      revisedDate: [''],
      completed: [''],
      verification: [''],
      departmentMachine: [],
      newAssignee: [''],
      closefile: [''],
      completeFile: [''],
      remarks: [''],
      NoofMisses: ['']
    });
    const actionsColumn = {
      field: 'actions',
      headerName: 'Actions',
      width: 100,
      resizable: true,
      filter: true,
      cellRenderer: (params: any): any => {
        if (this.permissionService.isUserHasPermission(this.isUpdate)) {
          if (params.data.Status !== 'Closed') {
            return `
          <div>
            <button mat-mini-fab
              color="primary"
              ptooltip="Action Delete"
              title="Edit Action"
              tooltipposition="top"
              class="viewRCA mat-focus-indicator mat-mini-fab mat-button-base mat-primary">
              <span class="mat-button-wrapper">
                <mat-icon role="img"
                  class="mat-icon notranslate material-icons mat-icon-no-color"
                  aria-hidden="true"
                  data-mat-icon-type="font">edit</mat-icon>
              </span>
            </button>
          </div>
        `;
          }
        }
        return '';
      }
    };
    this.columnDefsallAction = [
      // {
      //   field: 'actions',
      //   headerName: 'Actions',
      //   width: 100,
      //   resizable: true,
      //   filter: true,
      //   cellRenderer: (params: any): any => {
      //     if (this.permissionService.isUserHasPermission(this.isUpdate)) {
      //       if (params.data.Status !== 'Closed') {
      //         return `
      //       <div>
      //       <button mat-mini-fab=""
      //       color="primary"
      //       ptooltip="Action Delete"
      //       title="Edit Action"
      //       tooltipposition="top"
      //       class="viewRCA mat-focus-indicator mat-mini-fab mat-button-base mat-primary" ng-reflect-color="primary"><span class="mat-button-wrapper"><mat-icon role="img" class="mat-icon notranslate material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">edit</mat-icon></span><span matripple="" class="mat-ripple mat-button-ripple mat-button-ripple-round" ng-reflect-disabled="false" ng-reflect-centered="false" ng-reflect-trigger="[object HTMLButtonElement]"></span><span class="mat-button-focus-overlay"></span></button>
      //        </div>
      //     `;
      //       }
      //     }
      //   },
      // },
      {
        field: 'RootCause',
        headerName: 'Root Cause',
        resizable: true,
        filter: true,
      },
      {
        field: 'Action',
        headerName: 'Action Name',
        resizable: true,
        width: 150,
        filter: true,
      },
      {
        field: 'PriorityLevel',
        headerName: 'Actions Criticality Level',
        resizable: true,
        width: 150,
        filter: true,
        valueFormatter: params => {
          switch (params.value) {
            case 3: return 'High';
            case 2: return 'Medium';
            case 1: return 'Low';
            default: return 'Unknown';
          }
        }
      },
      {
        field: 'KPIName',
        headerName: 'KPI Name',
        resizable: true,
        filter: true,
        hide: inputData.ModuleId !== 3  // Hide the column unless module is 3
      },
      {
        field: 'Status',
        headerName: 'Status',
        resizable: true,
        filter: true,
        width: 100,
        cellStyle: function (params: any): any {
          if (params.value == 'Open')
            return { color: 'white', backgroundColor: 'gray' };
          else if (params.value == 'InProgress')
            return { color: 'white', backgroundColor: 'orange' };
          else if (params.value == 'Complete')
            return { color: 'white', backgroundColor: '#1cd51c' };
          else if (params.value == 'Closed')
            return { color: 'white', backgroundColor: 'green' };
          else if (params.value == 'Delayed')
            return { color: 'white', backgroundColor: 'brown' };
          else if (params.value == 'Rejected')
            return { color: 'white', backgroundColor: 'red' };
        },
      },
      {
        field: 'CreatedAt',
        headerName: 'Assigned Date',
        resizable: true,
        filter: true,
        valueFormatter: (params: any) => this.formatCellData(params.value, 'dateTime'),
        width: 150,
      },
      {
        field: 'AssingedBy',
        headerName: 'Assigned To',
        resizable: true,
        filter: true,
        width: 150,
      },
      {
        field: 'TargetDate',
        headerName: 'Target Date',
        resizable: true,
        filter: true,
        valueFormatter: (params: any) => this.formatCellData(params.value, 'dateOnly'),
        width: 150,
      },
      {
        field: 'NoOfMisses',
        headerName: 'No of Misses',
        resizable: true,
        filter: true,
      },
      {
        field: 'RevisedDate',
        headerName: 'New Target Date',
        resizable: true,
        filter: true,
        valueFormatter: (params: any) => this.formatCellData(params.value, 'dateOnly'),
        width: 150,
      },
      {
        field: 'ActionCompleted',
        headerName: 'Completed',
        resizable: true,
        filter: true,
        width: 130,
      },
      {
        field: 'ClosedFile',
        headerName: 'Closed File',
        sortable: true,
        resizable: true,
        filter: true,
        cellRenderer: function (params: any) {
          let html = '';
          if (params && params.value) {
            html = `<button mat-mini-fab=""
             color="primary"
             ptooltip="View document"
             title="View document"
             tooltipposition="top"
             class="viewDocument mat-focus-indicator mat-mini-fab mat-button-base mat-primary" ng-reflect-color="primary"><span class="mat-button-wrapper"><mat-icon role="img" class="viewDocument mat-icon notranslate material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">visibility</mat-icon></span><span matripple="" class="viewDocument mat-ripple mat-button-ripple mat-button-ripple-round" ng-reflect-disabled="false" ng-reflect-centered="false" ng-reflect-trigger="[object HTMLButtonElement]"></span><span class="mat-button-focus-overlay"></span></button>
            `;
          }
          return html;
        },
      },
      {
        field: 'Remarks',
        headerName: 'Remarks',
        resizable: true,
      },
      {
        field: 'M_Classification',
        headerName: 'M Classification',
        sortable: true,
        resizable: true,
        filter: true,
        valueGetter: (params) => {
          const id = params.data.M_Classification;
          if (id === null) {
            return '';
          }
          const classification = this.mClassificationTypes.find(type => type.Id === id);
          return classification ? classification.Name : '';
        }
      }
    ];
    // Only insert Actions column if viewHeader is not false
    if (inputData?.viewHeader !== false) {
      const rootCauseIndex = this.columnDefsallAction.findIndex(col => col.field === 'RootCause');
      const insertIndex = rootCauseIndex !== -1 ? rootCauseIndex : this.columnDefsallAction.length;
      this.columnDefsallAction.splice(insertIndex, 0, actionsColumn);
    }
  }
  disableBeforeCurrentDate = (current: Date): boolean => {
    // Disable dates before today (May 26, 2025, in this context)
    return current <= new Date(); // Months are 0-based in JavaScript (4 = May)
  };
  formatCellData(value: any, formatType: string): string {
    return this.userConfigService.formatField(value, formatType);
  }
  ngOnInit() {
    this.getEmployees();
    this.userSession = this.baseApi.getUserSession();
    this.addActionForm.get('actionType')?.setValue('Corrective');
    this.getOverallActions();
    // this.getDepartmentsMachine();
    this.getLangWords();
    if (this.inputData.ModuleId == 0) {
      this.showDepartment = false;
    }
    else {
      this.showDepartment = true;
    }
    if (this.inputData.editMode) {
      this.editMode = this.inputData.editMode;
      this.editRow(this.inputData?.params);
    }
    this.getMClassificationList();
  }
  getEmployees() {
    this.spinner.show()
    this.employeeService.getAllEmployees().pipe(finalize(() => this.spinner.hide())).subscribe(
      (res: any) => {
        this.employees = res;
        this.masterUserList = this.employees
      },
      (err: any) => { }
    )
  }
  getMClassificationList() {
    this.actionplanService.getMClassification().subscribe(
      (response) => {
        this.mClassificationTypes = response;
      },
      (error) => {
        this.toaster.error('Error', 'Something Went Wrong');
      }
    );
  }
  cellClickedActionTable(params: any) {
    let col = params.colDef.field;
    this.actionSelectedRow = params.node;

    let classList = params.event.target.classList;
    if (col === 'actions') {
      if (
        classList.contains('mat-icon-no-color') ||
        classList.contains('viewRCA')
      ) {
        this.editMode = true;
        this.inputData.viewHeader = true;
        this.editRow(params);
      }
    }
    if (col === 'ClosedFile') {
      if (classList.contains('viewDocument')) {
        this.doc =
          this.blobStorageUrl +
          params.data.ClosedFile;
        const fileType = params.data.ClosedFile.split('.').pop();
        if (
          fileType === 'jpeg' ||
          fileType === 'jpg' ||
          fileType === 'png' ||
          fileType === 'gif'
        ) {
          this.images = [];
          this.fileType = 'img';
          this.images.push(this.doc);
          console.log(this.images)
        } else {
          this.fileType = 'doc';
        }
        this.displayMaximizable = true;
        setTimeout(() => {
          var containerFullScreenElement = document.getElementById(
            'ngx-fs-btn'
          ) as HTMLElement;
          for (var i = 0; i < containerFullScreenElement.children.length; i++) {
            if (
              containerFullScreenElement.children[i].classList.contains(
                'fa-arrows-alt'
              )
            ) {
              containerFullScreenElement.style.right = '6rem';
              containerFullScreenElement.style.top = '18px';
              break;
            }
          }
        }, 300);
      }
    }
  }

  localizeHeader(parameters: ICellRendererParams): string {
    const headerIdentifier = parameters.colDef.field;
    return this.translate.instant(headerIdentifier);
  }

  openFile(type: any): void {
    if (type === 'pic') {
      this.imageInput.nativeElement.click();
    } else {
      this.fileInput.nativeElement.click();
    }
  }

  readFile(event: any, type: any): void {
    if (event.target.files.length !== 1) throw new Error('Cannot use multiple files');
    const allowedImageTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    const allowedOtherTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', 'application/pdf'];
    if (type === 'pic') {
      if (!allowedImageTypes.includes(event.target.files[0].type)) {
        this.toaster.error('Error', 'Please upload only image file');
        return;
      }
      this.imagefile = event.target.files[0];
    } else {
      if (!allowedOtherTypes.includes(event.target.files[0].type)) {
        this.toaster.error('Error', 'Please upload only pdf or excel file');
        return;
      }
      this.filefile = event.target.files[0];
    }

    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (type === 'pic') {
          this.imagefileUrl = reader.result as string;
        } else {
          this.filefileUrl = reader.result as string;
        }
      };
    }
  }

  deleteFile(type: any): void {
    if (type === 'pic') {
      this.imagefileUrl = '';
      this.imagefile = '';
    } else {
      this.filefile = '';
      this.filefileUrl = '';
    }
  }

  imageZoomModal(): void {
    if (this.editMode == false) {
      this.dialog.open(ImageDialogComponent, {
        height: '90%',
        width: '90%',
        data: this.imagefileUrl,
      });
    } else {
      this.dialog.open(ImageDialogComponent, {
        height: '90%',
        width: '90%',
        data: this.data.addImageSrc || environment.blobStorageUrl + this.data.UploadFile,
      });
    }
  }

  data: any = [];

  downloadPDF() {
    if (!this.filefileUrl) return;
    var a = document.createElement("a"); //Create <a>
    a.href = this.filefileUrl; //Image Base64 Goes here
    a.download = "file.pdf";
    a.click();
  }

  addGetMinDate(type: any): any {
    if (type === 'Revised') {
      const date = this.addActionForm.value.targetDate
        ? this.addActionForm.value.RevisedDate
        : this.addActionForm.value.TargetDate;
      const currentDate = new Date(date);

      const minDateStartFrom = new Date(
        currentDate.setDate(currentDate.getDate() + 1)
      );

      return (current: Date): boolean =>
        differenceInCalendarDays(current, minDateStartFrom) < 0;
    } else if (type === 'Target') {
      const currentDate = new Date();
      const minDateStartFrom = new Date(
        currentDate.setDate(currentDate.getDate())
      );

      return (current: Date): boolean =>
        differenceInCalendarDays(current, minDateStartFrom) < 0;
    }
  }

  getMinDate(type: any): any {
    if (type === 'Revised') {
      const date = this.addActionForm.value.revisedDate
        ? this.addActionForm.value.revisedDate
        : this.addActionForm.value.targetDate;
      const currentDate = new Date(date);

      const minDateStartFrom = new Date(
        currentDate.setDate(currentDate.getDate() + 1)
      );

      return (current: Date): boolean =>
        differenceInCalendarDays(current, minDateStartFrom) < 0;
    } else if (type === 'Target') {
      const currentDate = new Date();
      const minDateStartFrom = new Date(
        currentDate.setDate(currentDate.getDate())
      );

      return (current: Date): boolean =>
        differenceInCalendarDays(current, minDateStartFrom) < 0;
    }
  }

  addDisableVerification = true;
  disableVerification = true;
  addDisableNewAssigne = true;
  showCloseFileInput: boolean;
  showCompleteFileInput: boolean = false;
  showinput: boolean;

  onChangeComplete(): void {
    if (this.addActionForm.value.completed === 'Yes') {
      this.addDisableVerification = false;
      this.disableVerification = false;

      this.addActionForm.get('verification').setValue('');
      this.showCompleteFileInput = true;
    }
    else {
      this.addDisableVerification = true;
      this.disableVerification = true;
      this.addActionForm.get('verification').setValue('');
      this.showCompleteFileInput = false;
    }
  }

  onChangeVerification(): void {
    if (this.addActionForm.value.verification === 'Disapproved') {
      this.addDisableNewAssigne = false;
    } else if (this.addActionForm.value.verification !== 'Disapproved') {
      this.addDisableNewAssigne = true;
    }
    if (this.addActionForm.value.verification === 'Approved') {
      this.showCloseFileInput = true;
    } else {
      this.showCloseFileInput = false;
    }
    
    // Handle remarks requirement for disapproved verification
    if (this.addActionForm.value.verification === 'Disapproved') {
      // Set remarks as required when verification is disapproved
      this.addActionForm.get('remarks')?.setValidators([Validators.required]);
    } else {
      // Remove required validation when not disapproved
      this.addActionForm.get('remarks')?.clearValidators();
    }
    this.addActionForm.get('remarks')?.updateValueAndValidity();
  }

  targetDate: any;
  RevisedDate: any;
  addActionPlan(): void {
    // Check for mandatory remarks when verification is disapproved
    if (this.addActionForm.value.verification === 'Disapproved' && (!this.addActionForm.value.remarks || this.addActionForm.value.remarks.trim() === '')) {
      this.toaster.warning('Warning', 'Please Fill The Remarks Field');
      return;
    }

    this.targetDate = this.addActionForm.value.targetDate;
    this.addStatus = this.addActionForm.value.targetDate && !this.addActionForm.value.revisedDate ? 'InProgress' : this.addActionForm.value.targetDate && this.addActionForm.value.revisedDate ? 'Delayed' : 'Open';

    if (this.addActionForm.value.completed === 'Yes') {
      this.addStatus = 'Complete';
    }

    if (this.addActionForm.value.verification === 'Approved') {
      this.addStatus = 'Closed';
    } else if (this.addActionForm.value.verification === 'Disapproved') {
      this.addStatus = 'ReOpened';
      this.addActionForm.get('completed').setValue('No');
    }
    const formdata = new FormData();
    formdata.append('file', this.filefile);
    formdata.append('image', this.imagefile);
    formdata.append('closedFile', this.closefile);
    formdata.append('completedFile', this.completefile);
    if (this.addActionForm.value.targetDate) {
      this.targetDate = this.addActionForm.value.targetDate;
      this.targetDate = new Date(this.targetDate);
      this.targetDate.setHours(new Date().getHours());
      this.targetDate.setMinutes(new Date().getMinutes());
      this.targetDate.setSeconds(new Date().getSeconds());
    }
    if (this.addActionForm.value.revisedDate) {
      this.RevisedDate = this.addActionForm.value.revisedDate;
      this.RevisedDate = new Date(this.RevisedDate);
      this.RevisedDate.setHours(new Date().getHours());
      this.RevisedDate.setMinutes(new Date().getMinutes());
      this.RevisedDate.setSeconds(new Date().getSeconds());
    }
    const key = {
      actionName: this.addActionForm.value.action,
      priorityLevel: this.addActionForm.value.priorityLevel,
      actionType: this.addActionForm.value.actionType,
      responsible: this.addActionForm.value.assignTo,
      targetDate: this.targetDate ? this.targetDate : null,
      status: this.addStatus,
      ID: this.inputData.ID,
      ModuleId: this.inputData.ModuleId,
      TableId: this.inputData.TableId ? this.inputData.TableId : null,
      mClassification: this.addActionForm.value?.mClassification
    };
    formdata.append('values', JSON.stringify(key));
    this.spinner.show();
    this.actionplanService.AddActionUserAction(formdata).pipe(finalize(() => {
      this.dialogRef.close(true);
      this.actionSaveUpdateEvent.emit(true); // custom event emitter;
      this.spinner.hide();
    })).subscribe(({
      next: (res: any) => {
        this.toaster.success('Success', 'Saved Successfully');
        this.resetForm();
      },
      error: (res: any) => {
        this.toaster.error('Error')
      }
    }))
  }

  resetForm() {
    this.editMode = false;
    this.imagefile = '';
    this.imagefileUrl = '';
    this.filefile = '';
    this.filefileUrl = '';
    this.closefile = '';
    this.closefileUrl = '';
    this.completefile = '';
    this.completefileUrl = '';
    this.showCloseFileInput = false;
    this.showCompleteFileInput = false;
    this.addActionForm.reset();
  }

  isResetButtonEnabled(): boolean {
    const formValues = this.addActionForm.value;
    for (const key in formValues) {
      if (formValues.hasOwnProperty(key) && formValues[key]) {
        return true;
      }
    }
    return false;
  }

  onGridReadyAction(params: any): any {
    this.gridApiActions = params.api;
    this.gridColumnApiActions = params.columnApi;
  }

  disableNewAssigne = true;
  getOverallActions() {
    const data = {
      meetingId: this.inputData.TableId,
      moduleId: this.inputData.ModuleId,
    };
    this.meetingService.getAllMeetingActions(data).subscribe(
      (response) => {
        this.overallMeetingActions = response;
      },
      (err: any) => {

      }
    );
  }
  editRow(params: any): void {
    if (!params) return;
    this.data = [];

    this.imagefile = '';
    this.filefile = '';
    this.closefile = '';
    this.completefile = '';
    this.imagefileUrl = '';
    this.filefileUrl = '';
    this.closefileUrl = '';
    this.completefileUrl = '';

    this.data = params.data;
    this.ModuleName = this.data.Module;
    this.UniqueCode = this.data.UniqueCode;
    this.HeaderId = this.data.HeaderId;
    this.currentAssigneeEmail = this.data.AssigneEmail;
    this.currentResponsibleEmail = this.data.ParticpantEmails;
    this.currentNodeDate = this.data.ObservedDate;
    this.addActionForm.get('action').setValue(this.data.Action);
    this.addActionForm.get('priorityLevel').setValue(this.data.PriorityLevel);
    this.addActionForm.get('assignTo').setValue(this.data.AssignTo);
    this.addActionForm.get('completed').setValue(this.data.ActionCompleted);
    this.addActionForm.get('remarks').setValue(this.data.Remarks);
    this.MissesCondition = true;
    if (this.data.ActionCompleted === 'No') {
      this.disableVerification = true;
      this.addDisableVerification = true;
      this.showCompleteFileInput = false;
      this.addActionForm.get('verification').setValue('');
    } else {
      this.disableVerification = false;
      this.addDisableVerification = false;
      this.showCompleteFileInput = true;
      this.addActionForm.get('verification').setValue(this.data.Verification);
    }
    if (this.data.Verification === 'Disapproved') {
      this.disableNewAssigne = false;
      this.showCloseFileInput = false;
      this.addActionForm.get('newAssignee').setValue(this.data.NewAssigneeId);
    } else if (this.data.Verification === 'Approved') {
      this.showCloseFileInput = true;
      this.disableNewAssigne = true;
      this.addActionForm.get('newAssignee').setValue('');
    } else {
      this.addActionForm.get('newAssignee').setValue('');
    }

    this.addActionForm.get('actionType').setValue(this.data.ActionType);
    if (this.data.RevisedDate !== null) {
      this.addActionForm.get('revisedDate').setValue(this.datePipe?.transform(new Date(this.data.RevisedDate), 'yyyy-MM-dd'));
    }
    if (this.data.TargetDate !== null) {
      this.addActionForm.get('targetDate').setValue(this.datePipe?.transform(new Date(this.data.TargetDate), 'yyyy-MM-dd'));
    }
    this.targetDate = this.data.TargetDate;
    this.addActionForm.get('rootcause')?.setValue(this.data.RootCause);
    this.addActionForm.get('mClassification')?.setValue(this.data.M_Classification);
    this.addActionForm.get('NoofMisses').setValue(this.data.NoOfMisses);

  }

  closeFile(event: any): void {
    if (event.target.files.length === 0) return;
    this.closefile = event.target.files[0];
  }

  completeFile(event: any): void {
    if (event.target.files.length === 0) return;
    this.completefile = event.target.files[0];
  }

  /*, will be needed later
  getDepartmentsMachine(): void {
    const key = {};
    this.departmentListMachine = [];
    this.filteredDepartmentListMachine = [];
    this.actionplanService.getDeptData(key).subscribe((res) => {
      this.departmentListMachine = res;
      this.filteredDepartmentListMachine = this.departmentListMachine.slice();
      if(this.editMode) {
        this.addActionForm.get('departmentMachine')?.setValue(this.inputData?.params.TypeId);
      }
      else {
        this.addActionForm.get('departmentMachine')?.setValue(this.departmentListMachine[0].TypeId);
      }
    },
    (error)=>{
      this.toaster.error('Error', error.message);
    });
  }
  */

  updateActionPlan(): void {
    // Check for mandatory remarks when verification is disapproved
    if (this.addActionForm.value.verification === 'Disapproved' && (!this.addActionForm.value.remarks || this.addActionForm.value.remarks.trim() === '')) {
      this.toaster.warning('Warning', 'Please Fill The Remarks Field');
      return;
    }

    this.Status = '';
    this.Status =
      this.addActionForm.value.targetDate &&
        !this.addActionForm.value.revisedDate
        ? 'InProgress'
        : this.addActionForm.value.targetDate &&
          this.addActionForm.value.revisedDate
          ? 'Delayed'
          : 'Open';

    if (this.addActionForm.value.targetDate) {
      this.targetDate = this.addActionForm.value.targetDate;
      this.targetDate = new Date(this.targetDate);
      this.targetDate.setHours(new Date().getHours());
      this.targetDate.setMinutes(new Date().getMinutes());
      this.targetDate.setSeconds(new Date().getSeconds());
    }
    if (this.addActionForm.value.revisedDate) {
      this.RevisedDate = this.addActionForm.value.revisedDate;
      this.RevisedDate = new Date(this.RevisedDate);
      this.RevisedDate.setHours(new Date().getHours());
      this.RevisedDate.setMinutes(new Date().getMinutes());
      this.RevisedDate.setSeconds(new Date().getSeconds());
    }
    if (this.addActionForm.value.completed === 'Yes') {
      this.Status = 'Complete';
    }
    if (this.addActionForm.value.verification === 'Approved') {
      this.Status = 'Closed';
    } else if (this.addActionForm.value.verification === 'Disapproved') {
      this.Status = 'ReOpened';
      this.addActionForm.get('completed').setValue('No');
    }

    const formdata = new FormData();
    formdata.append('file', this.filefile);
    formdata.append('image', this.imagefile);
    formdata.append('closedFile', this.closefile);
    formdata.append('completedFile', this.completefile);

    const key = {
      actionId: this.data?.ID,
      actionName: this.addActionForm.value.action,
      PriorityLevel: this.addActionForm.value.priorityLevel,
      actionType: this.addActionForm.value.actionType,
      responsible: this.addActionForm.value.assignTo,
      departmentId: this.addActionForm.value.departmentMachine,
      targetDate: this.targetDate ? this.targetDate : null,
      revisedDate: this.RevisedDate ? this.RevisedDate : null,
      actionCompleted: this.addActionForm.value.completed,
      Verification: this.addActionForm.value.verification,
      remarks: this.addActionForm.value.remarks,
      newAssignee: this.addActionForm.value.newAssignee
        ? this.addActionForm.value.newAssignee
        : null,
      status: this.Status,
      headerId: this.HeaderId,
      rootCause: this.addActionForm.value.rootcause,
      mClassification: this.addActionForm.value?.mClassification,
      NoofMisses: this.addActionForm.value.NoofMisses,
      ModuleId: this.inputData.ModuleId,
      TableId: this.inputData.TableId,
    };

    formdata.append('values', JSON.stringify(key));
    this.spinner.show();
    this.actionplanService.editActionPlan(formdata).pipe(finalize(() => {
      this.dialogRef.close(true);
      this.spinner.hide();
      this.resetForm();
      this.actionSaveUpdateEvent.emit(true); // custom event emitter
    })).subscribe((res: any) => {
      if (res[0].Column1 === 'Updated Successfully') {
        this.toaster.success('Success', `Updated Sucessfully `);
      }
    },
      (error: any) => {
        this.toaster.error('Error', error.message);
      });
  }

  closeModal(): void {
    this.dialogRef.close();
    this.resetForm();
  }

  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    const userMenus = this.baseApi.getUserPermissionsSession();
    this.moduleId = userMenus.find(x => x.menuId === this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      // if (this.langObj) {
      //   this.gridApi.refreshHeader();
      // }
    });
  }


  onRevisedDateChange(row: any, data: any) {
    if (this.editMode) {


      if (this.MissesCondition && row) {
        const currentMisses = this.addActionForm.get('NoofMisses').value || 0;
        this.addActionForm.get('NoofMisses').setValue(currentMisses + 1);
        // data.NoOfMisses++;
        this.MissesCondition = false;
      } else if (!this.MissesCondition && !row) {
        const currentMisses = this.addActionForm.get('NoofMisses').value || 0;
        this.addActionForm.get('NoofMisses').setValue(currentMisses - 1);
        // data.NoOfMisses--;
        this.MissesCondition = true;
      }
    }
    // row.MinRevisedDate = (current: Date): boolean =>
    // // Can not select days before today and today
    // differenceInCalendarDays(current, new Date(row.TargetDate)) < 0;
  }


}
